import AccountSettingsIconComponent from '~/assets/svg/accountSettings.svg'
import HiringKitIconComponent from '~/assets/svg/hiringKit.svg'
import AddIconComponent from '~/assets/svg/add.svg'
import AiSparklesIconComponent from '~/assets/svg/ai-sparkles.svg'
import ArrowLeftNarrowIconComponent from '~/assets/svg/arrowLeftNarrow.svg'
import ArrowOutwardIconComponent from '~/assets/svg/arrowOutward.svg'
import ArrowRightNarrowIconComponent from '~/assets/svg/arrowRightNarrow.svg'
import AssignmentIconComponent from '~/assets/svg/assignment.svg'
import AuditIconComponent from '~/assets/svg/audit.svg'
import CloseIconComponent from '~/assets/svg/close.svg'
import CopyIconComponent from '~/assets/svg/copy.svg'
import DashboardIconComponent from '~/assets/svg/dashboard.svg'
import DeleteIconComponent from '~/assets/svg/delete.svg'
import DownloadIconComponent from '~/assets/svg/download.svg'
import EditIconComponent from '~/assets/svg/edit.svg'
import ExternalLinkIconComponent from '~/assets/svg/externalLink.svg'
import HelpIconComponent from '~/assets/svg/help.svg'
import InfoIconComponent from '~/assets/svg/info.svg'
import LogoIconComponent from 'assets/svg/yogen_logo.svg'
import NotificationIconComponent from '~/assets/svg/notification.svg'
import VerticalMenuIconComponent from '~/assets/svg/verticalMenu.svg'
import WorkIconComponent from '~/assets/svg/work.svg'
import TrainingIconComponent from '~/assets/svg/training.svg'
// Define the valid icon components first
export type Icon =
  | typeof AccountSettingsIconComponent
  | typeof HiringKitIconComponent
  | typeof AddIconComponent
  | typeof AiSparklesIconComponent
  | typeof ArrowLeftNarrowIconComponent
  | typeof ArrowOutwardIconComponent
  | typeof ArrowRightNarrowIconComponent
  | typeof AssignmentIconComponent
  | typeof AuditIconComponent
  | typeof CloseIconComponent
  | typeof CopyIconComponent
  | typeof DashboardIconComponent
  | typeof DeleteIconComponent
  | typeof DownloadIconComponent
  | typeof EditIconComponent
  | typeof ExternalLinkIconComponent
  | typeof HelpIconComponent
  | typeof InfoIconComponent
  | typeof LogoIconComponent
  | typeof NotificationIconComponent
  | typeof VerticalMenuIconComponent
  | typeof WorkIconComponent
  | typeof TrainingIconComponent
// Define the corresponding names
const iconNamesList = [
  'accountSettings',
  'hiringKit',
  'add',
  'aiSparkles',
  'arrowOutward',
  'arrowRightNarrow',
  'arrowLeftNarrow',
  'assignmentComponent',
  'audit',
  'close',
  'copy',
  'dashboard',
  'delete',
  'download',
  'edit',
  'externalLink',
  'help',
  'info',
  'logo',
  'notification',
  'verticalMenu',
  'work',
  'training',
] as const

export type IconName = (typeof iconNamesList)[number]

export const iconNames: Record<IconName, IconName> = iconNamesList.reduce(
  (obj, key) => {
    obj[key] = key
    return obj
  },
  {} as Record<IconName, IconName>,
)

// Type-safe map of names to icons
export type IconMap = Record<IconName, Icon>

// Create the actual mapping
export const iconMap: IconMap = {
  accountSettings: AccountSettingsIconComponent,
  hiringKit: HiringKitIconComponent,
  add: AddIconComponent,
  aiSparkles: AiSparklesIconComponent,
  arrowLeftNarrow: ArrowLeftNarrowIconComponent,
  arrowOutward: ArrowOutwardIconComponent,
  arrowRightNarrow: ArrowRightNarrowIconComponent,
  assignmentComponent: AssignmentIconComponent,
  audit: AuditIconComponent,
  close: CloseIconComponent,
  copy: CopyIconComponent,
  dashboard: DashboardIconComponent,
  delete: DeleteIconComponent,
  download: DownloadIconComponent,
  edit: EditIconComponent,
  externalLink: ExternalLinkIconComponent,
  help: HelpIconComponent,
  info: InfoIconComponent,
  logo: LogoIconComponent,
  notification: NotificationIconComponent,
  verticalMenu: VerticalMenuIconComponent,
  work: WorkIconComponent,
  training: TrainingIconComponent,
}
